<script lang="ts">
  import { config } from '#app/config'
  import Flash from '#app/lib/components/flash.svelte'
  import { i18n } from '#user/lib/i18n'

  const { ongoingReindexation } = (config.maintenance || {})
</script>

{#if ongoingReindexation}
  <div class="search-maintenance-flash">
    <Flash
      state={{
        type: 'warning',
        message: i18n('The search engine is under maintenance: search results may be missing.'),
      }}
    />
  </div>
{/if}

<style lang="scss">
  @import "general/scss/utils";
  .search-maintenance-flash{
    :global(.flash){
      margin: 0;
    }
  }
</style>
